import { Onboarding } from '@/containers/onboarding';
import { useGo } from '@/lib/useGo';

export default function OnboardingRoute() {
  const go = useGo();
  return <Onboarding go={go} />;
}
